<template>
  <b-container class="px-0">
    <loader v-if="loader"></loader>
    <b-row v-else class="user-bill" no-gutters>
      <b-col class="user-bill-info" cols="12" md="7" lg="8" xl="9">
        <div class="bill-info-head">
          {{'LSinfoHead' | localize}}
        </div>
        <div class="info-component">
          <div class="info-head-line">
            {{'LSPayHead' | localize}}:
          </div>
          <div class="info-line">
            {{userAccountsinfo.account_id}}
          </div>
        </div>
        <div class="info-component">
          <div class="info-head-line">
            {{'LSinfoFIO' | localize}}:
          </div>
          <div class="info-line">
            {{userAccountsinfo.surname}} {{userAccountsinfo.f_name}} {{userAccountsinfo.m_name}}
          </div>
        </div>
        <div class="info-component">
          <div class="info-head-line">
            {{'LSinfoAdress' | localize}}:
          </div>
          <div class="info-line">
            {{userAccountsinfo.street_name}} {{userAccountsinfo.dom}}, кв {{userAccountsinfo.flat_num}}
          </div>
        </div>
        <div class="info-component">
          <div class="info-head-line">
            {{'LSinfoTelephones' | localize}}:
          </div>
          <div class="info-line">
            {{userAccountsinfo.ntel}}
          </div>
        </div>
        <div class="info-component">
          <div class="info-head-line">
            {{'LSinfoFlatSquere' | localize}}:
          </div>
          <div class="info-line">
            {{userAccountsinfo.sq_kv}}
          </div>
        </div>
        <div class="info-component">
          <div class="info-head-line">
            {{'LSinfoFlatUsers' | localize}}:
          </div>
          <div class="info-line">
            {{userAccountsinfo.c_pipl}} чол.
          </div>
        </div>
        <div class="info-component">
          <div class="info-head-line">
            {{'LSinfoFlatBeneficiaryUsers' | localize}}:
          </div>
          <div class="info-line">
            {{userAccountsinfo.c_pipl_lg}} чол.
          </div>
        </div>
      </b-col>

      <b-col class="user-bill-balans" cols="12" md="5" lg="4" xl="3">
        <div class="bill-info-head">
          {{'LSinfoBill' | localize}}
        </div>

        <div class="bill-info-body ">
          <div class="tarif-info" v-if="tarif">
            {{'userAddressTarif' | localize}} {{tarif.date_start.replace(/-/g, '.')}}:<strong
              class="ml-1">{{tarif.tarif}}</strong> грн
          </div>
          <div class="bill-balans-info">
            {{userAccountsinfo.balance_today}} грн
          </div>
          <div class="d-flex">
            <b-form-select class="mx-4 my-4" v-model="type_pay" :options="options">
              <template #first>
                <b-form-select-option :value="null" disabled>
                  {{ 'mainPayType' | localize }}
                </b-form-select-option>
              </template>
            </b-form-select>
          </div>

          <b-button size="sm" variant="outline-success" class="  style-button button-pay mx-auto"
            :href="paylink(userAccountsinfo.account_id)" target="_blank">
            {{'mainPayButton' | localize}}
            <div class="style-button-icon">
              <b-icon icon="credit-card"></b-icon>
            </div>
          </b-button>

        </div>
      </b-col>
    </b-row>

    <b-row no-gutters>
      <b-col cols="12" class="bottom-buttons">
        <b-button size="xs" variant="outline-danger" class=" style-button button-message"
          :to="{ path:`${route_prefix}/feedback/${user_id}`}">
          {{'mainFeedBackButton' | localize}}
          <div class="style-button-icon">
            <b-icon icon="envelope"></b-icon>
          </div>
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="answers_response" class="answers-block-container" no-gutters>
      <b-col class="answers-block" cols="12">
        <div class="bill-info-head mb-2">
          {{'LSLetterHistory' | localize}}
        </div>
        <div v-if="answers_response[0].err === 'Нет ответа !'" class="empty-response">
          {{'LSLetterHistoryNoAnswers' | localize}}
        </div>
        <div v-else-if="!answers_response[0].err" v-for="item of answers_response" :key="item.index"
          class="answers-response">
          <div class="answers-message">
            <div class="message-header">
              {{'LSLetterText' | localize}}:
            </div>
            <div class="message-text">
              {{item.message_text}}
            </div>
          </div>
          <div class="answers-text">
            <div class="answers-header">
              {{'LSAnswerText' | localize}}:
            </div>
            <div class="answers-message-text">
              {{item.answer_text}}
            </div>
          </div>
          <b-button size="xs" variant="outline-danger" class=" style-button button-message-history-delete mt-4 mb-2"
            @click="deleteMessage(item.id)">
            {{'LSDeleteButton' | localize}} <div class="style-button-icon"> <b-icon icon="envelope"></b-icon> </div>
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>

</template>
<script>
import { mapGetters } from 'vuex'
import loader from '../Loader'
import config from '@/config'
import axios from 'axios'
import { sha256 } from 'js-sha256';
import base64url from "base64url";
export default {
  data: ()=>({
    loader: false,
    user_account_residents: [],
    user_id: null,
    answers_response: null,
    pay: 0,
    account: window.location.pathname.split('/').pop(),
    route_prefix: config.ROUTE_PREFIX,
    tarif: null,
    type_pay: 'privat',
    options: [
      { value: 'privat', text: 'Приват24' },
      { value: 'zss', text: 'Запоріжзв`язоксервіс' },
    ],
  }),
  async mounted() {
    this.loader = true
    this.user_id = window.location.pathname.split('/').pop()
    await this.$store.dispatch('userAccountsInfoData')
        if(this.userAccountsinfo.err === "Сессия просрочена !"){
      await this.$store.dispatch('logout')
      this.$router.push({  name: 'Login' })
      this.$toastLocalized("sessionTerminated")
    }
    await this.$store.dispatch('userAccountsBillInfoData')
    await this.$store.dispatch('userAccountSubsidyInfo')
    await this.$store.dispatch('fetchAnswers')
    this.tarifInfo()
    this.answers_response = this.answersData
    this.user_account_residents = this.userAccountResidentsData

    this.loader = false
    this.pay = this.userAccountsinfo.balance_today

  },
  computed: mapGetters(['userAccountsinfo','userAccountResidentsData', 'answersData', 'locale']),
  methods: {
    async tarifInfo(){
      const key = localStorage.getItem("weltumKey")
      const Time = Date.now().toString()
      const test = sha256.hmac(key, Time);
      const Hmac = base64url(test)
      const API_URL = config.API_URL

      await axios.get(
        `${API_URL}/api/rest/receipt/tarif?lico=${this.user_id}&secret_key=${key}`, 
        {
          headers:{
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Hmac': Hmac,
          'X-Time': Time, 
          }
        },
        
      ).then((response) => {
        
        this.tarif = response.data.items[0]
      })
    },
    showModal() {
      this.$refs['bv-modal-example'].show()
    },
    hideModal() {
      this.$refs['bv-modal-example'].hide()
    },
    async deleteMessage(messageId){
      const message = {
        id: messageId,
        secret_key: localStorage.weltumKey
      }
      await this.$store.dispatch('deleteMessageAction', message)
      this.answers_response.forEach( i => {
        if (i.id === message.id) {this.answers_response.splice(i, 1)}
      })
      this.$messageLocalized("messageDeleted")
    },
    async portmonePayMethod(){
      await this.$store.dispatch('portmonePay')
    },
    async privatPayMethod(){
      await this.$store.dispatch('privatPay')
    },
    async zssPayMethod(){
      await this.$store.dispatch('ZssPay')
    },
    paylink: function (account) {
      if (this.type_pay === 'privat') {
        return this.privatlink(account);
      } else if (this.type_pay === 'zss') {
        return this.zsslink(account);
      }
      return '#'; // Встановити значення за замовчуванням, якщо тип не вибраний
    },
    privatlink: function (account) {
      let url = 'https://next.privat24.ua/payments/form/{"token":"8645c2735a4bc4a50540b183b9969ed6z4xh3v8x","personalAccount":"' + account + '"}';
      return url;

    },
    zsslink: function (account){
      let url = 'https://ips.ua/faces/api/proc?t=ue6TwAuZjJhAksHHuL0x_0cDxnrlhUufR2OHtiQGzkw.&p=3&b='+ account;

      return url;
     
    }
  },
  components: {
    loader,
  }
}
</script>
